import React from "react";
import Header from "./components/header"
import Body from "./components/body"


function Products () {
    return (
        <div>
            <title>Products | PaladiumTechServiceLimited</title>
            <Header />
            <Body />
        </div>
    )
}

export default Products;